module.exports = __webpack_public_path__ + "images/bubbles_left_top.png";